import { createLayeredConstructionApi } from "features/shared/layered-construction-config/api/createLayeredConstructionApi";
import { LayeredConstructionTab } from "features/shared/layered-construction-config/components/LayeredConstructionTab";
import { buildVariant } from "features/shared/layered-construction-config/model/variants";

const WALL_VARIANT = buildVariant({
  cacheRoot: "wallConfigTab",
  catalogSegment: "wall-type-db",
  catalogTypeNameKey: "wallTypeName",
  countLabelKey: "walls",
  groupSegment: "wall-user-defined-types",
  i18nKey: "wall",
  typeDbIdKey: "wallTypeDbId",
  typeDbOverrideKey: "wallTypeDb",
});

export const WallTab = ({ projectId }: { projectId: string }) => (
  <LayeredConstructionTab
    api={createLayeredConstructionApi(WALL_VARIANT)}
    projectId={projectId}
    variant={WALL_VARIANT}
  />
);
